import gql from 'graphql-tag';

const CREATE_WORKSPACE = gql`
  mutation createWorkspace($data: CreateWorkspaceInput!) {
    createWorkspace(data: $data) {
      id
      name
      mode
    }
  }
`;

const REMOVE_USER_WORKSPACE = gql`
  mutation removeUserWorkspace($userId: ID!, $workspaceId: ID!) {
    removeUserFromWorkspace(userId: $userId, workspaceId: $workspaceId) {
      affectedRows
    }
  }
`;

const SET_CURRENT_WORKSPACE = gql`
  mutation setCurrentWorkspace($userId: ID!, $workspaceId: ID!) {
    setCurrentWorkspace(userId: $userId, workspaceId: $workspaceId) {
      affectedRows
    }
  }
`;

const UPDATE_WORKSPACE_BY_ID = gql`
  mutation UpdateWorkspaceById($data: UpdateWorkspaceInput, $id: ID!) {
    updateWorkspaceById(data: $data, id: $id) {
      id
      name
      mode
      workspaceUrl
      logo
      zipCode
      street
      city
      state
      countryId
      currency
      isMonitorable
    }
  }
`;

const UPDATE_WORKSPACE_MONITORING = gql`
  mutation UpdateWorkspaceMonitoring($id: ID!, $isMonitorable: Boolean!) {
    updateWorkspaceMonitoring(id: $id, isMonitorable: $isMonitorable) {
      id
      isMonitorable
    }
  }
`;

export default {
  CREATE_WORKSPACE,
  REMOVE_USER_WORKSPACE,
  SET_CURRENT_WORKSPACE,
  UPDATE_WORKSPACE_BY_ID,
  UPDATE_WORKSPACE_MONITORING,
};
